// Module
var code = "<mx-select ng-if=\"vm.condition.__enumeration && vm.condition.__enumeration.length>0\" items=\"vm.condition.__enumeration\" ng-model=\"vm.condition.value\" ng-required=\"true\" item-title-field=\"title\" item-id-field=\"value\"></mx-select>";
// Exports
export default code;